RivalIQ.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const Users = RivalIQ.data.CacheLayer.extend({
        name: 'Users',
        cacheKeys: [
            'account_id',
            'user_id'
        ],

        loadData: function (attrs) {
            if (attrs.user_id) {
                const user = new RivalIQ.models.User({
                    id: attrs.user_id
                });
                return user.fetch().then(function () {
                    return user;
                });
            }

            const users = new RivalIQ.collections.Users();
            _.extend(users, attrs);

            return users.fetch().then(function () {
                return users;
            });
        },

        fetch: function (account, userId) {
            const me = this;

            account = account || RivalIQ.state.account;
            return me.getOrLoad({
                account_id: account.id,
                user_id: userId
            });
        }
    });

    data.users = new Users();
});
